import React, { useState } from 'react';
import { toast } from 'sonner';
import { CalendarClock, Loader2 } from 'lucide-react';
import { withOverride, errMsg } from './porters/porterUi';

const cls = 'mt-1 w-full h-11 rounded border border-slate-200 bg-white px-2 text-base';

const offerEmail = (item, authFetch, msg) => {
  if (!item.email) { toast.success(msg); return; }
  toast.success(msg, {
    description: 'Email the customer about the change?',
    action: {
      label: 'Notify customer',
      onClick: async () => {
        try { await authFetch('post', `/admin/estimate/${item.id}/notify-update`); toast.success('Customer notified by email.'); }
        catch { toast.error("Couldn't send email."); }
      },
    },
    duration: 10000,
  });
};

export const RescheduleEditor = ({ item, drivers, authFetch, onSaved }) => {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({});
  const [saving, setSaving] = useState(false);
  const start = () => { setF({ date: item.booking?.date || '', time: item.booking?.time || '09:00', driver_id: item.driver_id || '' }); setOpen(true); };

  const save = async () => {
    if (!f.date || !f.time) return toast.error('Pick a date and time.');
    setSaving(true);
    try {
      const { data } = await withOverride((override_reason) => authFetch('patch', `/admin/estimate/${item.id}/booking`, { date: f.date, time: f.time, keep_crew: true, driver_id: f.driver_id || null, override_reason }));
      (data.porters_dropped || []).forEach(p => toast.warning(`Porter taken off: ${p}`));
      setOpen(false);
      offerEmail(item, authFetch, `Moved to ${f.date} at ${f.time}`);
      onSaved?.({ closed: true });
    } catch (e) {
      if (e.cancelled) toast('Not moved — pick another driver or date.');
      else toast.error(errMsg(e, "Couldn't change the date."));
    } finally { setSaving(false); }
  };

  if (!open) {
    return (
      <button type="button" onClick={start} className="inline-flex items-center gap-1.5 text-sm font-bold text-[color:var(--mv-orange)] h-11 px-3 -ml-3 rounded-md hover:bg-orange-50" data-testid={`resched-open-${item.ref}`}>
        <CalendarClock className="w-3.5 h-3.5" /> Change date / time
      </button>
    );
  }
  return (
    <div className="rounded-md border border-orange-200 bg-orange-50 p-3 space-y-2" data-testid={`resched-panel-${item.ref}`}>
      <div className="grid grid-cols-2 gap-2">
        <label className="block"><span className="text-[10px] font-black uppercase tracking-wider text-slate-500">Date</span>
          <input type="date" value={f.date} onChange={(e) => setF({ ...f, date: e.target.value })} className={cls} data-testid="resched-date" /></label>
        <label className="block"><span className="text-[10px] font-black uppercase tracking-wider text-slate-500">Time</span>
          <input type="time" value={f.time} onChange={(e) => setF({ ...f, time: e.target.value })} className={cls} data-testid="resched-time" /></label>
        <label className="block col-span-2"><span className="text-[10px] font-black uppercase tracking-wider text-slate-500">Driver</span>
          <select value={f.driver_id} onChange={(e) => setF({ ...f, driver_id: e.target.value })} className={cls} data-testid="resched-driver">
            <option value="">Unassigned</option>
            {drivers.map(d => <option key={d.id} value={d.id}>{d.name}{d.id === item.driver_id ? ' (current)' : ''}</option>)}
          </select></label>
      </div>
      <div className="text-[11px] text-slate-600">The driver and porters stay on this job unless you change the driver here.</div>
      <div className="flex justify-end gap-2">
        <button type="button" onClick={() => setOpen(false)} className="text-sm font-bold text-slate-500 h-11 px-4" data-testid="resched-cancel">Close</button>
        <button type="button" onClick={save} disabled={saving} className="h-11 px-5 rounded-md bg-[color:var(--mv-navy)] text-white text-sm font-bold inline-flex items-center gap-1" data-testid="resched-save">
          {saving && <Loader2 className="w-3.5 h-3.5 animate-spin" />} Save
        </button>
      </div>
    </div>
  );
};
